import {createRouter, createWebHashHistory} from "vue-router";
import routes from "@/routes";
import store from "@/store";

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('route', to)
    if(to.name === 'home' && store.getters['mustLogin'] && !store.getters['token']){
        next({name: 'login'})
    }else if(to.name === 'login' && store.getters['token']){
        next({name: 'home'})
    }else{
        next()
    }
})

export default router
